import { useEffect, useState } from 'react'
import { MAIN_HOST, SPRITE } from '#constants.ts'

export function useIsSpriteCached() {
  const [isSpriteCached, setIsSpriteCached] = useState(false)
  useEffect(() => {
    const img = new Image()
    img.src = MAIN_HOST + SPRITE
    setIsSpriteCached(img.complete)
  }, [])

  return isSpriteCached
}
